// extracted by mini-css-extract-plugin
export default {"chips":"Chips_chips__O0MLO","title":"Chips_title__Sma-D","chipsBlock":"Chips_chipsBlock__RjBZc","image":"Chips_image__e7uiy"};